import { defineContent, type DefinedContent } from '@post-office/define-content';

/**
 * Kept free of React and ADS imports: the placement `index.ts` that reads this is loaded on the
 * server, so pulling the modal's component tree in here would bundle frontend code into the backend.
 */
export const registeredContent: DefinedContent<
	[
		'modalTitle',
		'modalDescription',
		'featureConsistent',
		'featureSetOnce',
		'featureOverride',
		'alternativeText',
		'buttonClose',
		'buttonChooseTheme',
		'buttonAccept',
	]
> = defineContent({
	default: {
		modalTitle: {
			id: 'shared-user-preferences-onboarding.modal.title',
			defaultMessage: 'Your display mode is now synced',
			description: 'Title for the theme sync modal',
			role: 'title',
		},
		modalDescription: {
			id: 'shared-user-preferences-onboarding.modal.description',
			defaultMessage: "All supported apps will now match your system's display mode by default.",
			description: 'Description text for the theme sync modal',
			role: 'description',
		},
		featureConsistent: {
			id: 'shared-user-preferences-onboarding.modal.feature.consistent',
			defaultMessage: 'Consistent look and feel',
			description: 'First feature bullet point',
		},
		featureSetOnce: {
			id: 'shared-user-preferences-onboarding.modal.feature.set-once',
			defaultMessage: 'Only set your display mode once',
			description: 'Second feature bullet point',
		},
		featureOverride: {
			id: 'shared-user-preferences-onboarding.modal.feature.override',
			defaultMessage: 'Choose display mode for individual apps',
			description: 'Third feature bullet point',
		},
		alternativeText: {
			id: 'shared-user-preferences-onboarding.modal.alternative-text',
			defaultMessage:
				'Alternatively, you can choose light or dark mode from the <appearanceSettings>Appearance</appearanceSettings> settings in your profile menu.',
			description: 'Alternative text explaining manual theme selection',
		},
		buttonClose: {
			id: 'shared-user-preferences-onboarding.modal.button.close',
			defaultMessage: 'Close modal',
			description: 'Accessible label for the close button of the theme sync modal',
		},
		buttonChooseTheme: {
			id: 'shared-user-preferences-onboarding.modal.button.choose-theme',
			defaultMessage: 'Choose mode',
			description: 'Choose mode button text',
		},
		buttonAccept: {
			id: 'shared-user-preferences-onboarding.modal.button.accept',
			defaultMessage: 'Okay',
			description: 'Okay button text',
		},
	},
});
